import axios from 'axios'
import baseResponseHandler from './baseResponseHandler'
import errorResponseHandler from './errorResponseHandler'

// const createInstance = () => {  
//   //const config = {}
//   const instance = axios.create()
//   //const instance = axios.interceptors.request.use((config) => {  
//   //config.headers["Content-Type"] = "application/json; charset=utf-8";
//   //config.withCredentials = true;
//   return instance  
// }
const responseHandler = {
  baseResponseHandler,
  errorResponseHandler
};

const api = axios;//createInstance()
api.interceptors.request.use((config) => {
    config.headers["Content-Type"] = "application/json; charset=utf-8";
    config.withCredentials = true;
    return config;
});

// add interceptors
for (const key in responseHandler) {
  if (responseHandler.hasOwnProperty(key)) {
    const { fulfilled, rejected } = responseHandler[key];
    api.interceptors.response.use(fulfilled, rejected);
  }
}

export default api